<script>

export default {
    props: {
        attendant: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            expand: false,
            visible: false,
            processing: false,
            items: {},
            filters: {
                q: null,
                page: 1
            }
        }
    },
    created() {
        this.items = this.getDefaultPagination()
        this.filters = _.merge(this.filters, this.$laravel.request)
        this.getItems()
    },
    methods: {
        handleSubmit(e) {
            e.preventDefault()
            this.pushState(this.filters)
            this.getItems()
        },
        handleReset(e) {
            e.preventDefault()
            this.filters = {
                q: null,
                page: 1
            }
        },
        tableChanged(pagination) {
            this.filters.page = pagination.current
            this.pushState(this.filters)
            this.getItems()
        },
        getItems() {
            this.loading = true

            this.$http
                .get(this.routeUri('api.classical.observation.show', {
                    user_hash: this.attendant
                }))
                .then(response => (this.items = response.data))
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!"

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            })

            this.getItems()
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    })
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                })
            }
        },
        handleClose() {
            this.$emit("handleClose", false)
        }
    }
}
</script>
<template>
    <a-card type="inner" size="small">
        <a-table
            class="pcp-table"
            :dataSource="items.data"
            :loading="loading"
            rowKey="id"
            :pagination="{
                current: items.current_page,
                total: items.total,
                defaultPageSize: items.per_page
            }"
            @change="tableChanged"
        >

            <a-table-column key="date" title="Tanggal" className="align-center text-small text-left">
                <template slot-scope="record">
                    <template v-if="record.class_session.session_time_start != null">
                        {{ moment(record.class_session.session_time_end).format('DD-MM-YYYY HH:mm:ss') }}
                    </template>
                </template>
            </a-table-column>

            <a-table-column key="observation" title="Observasi" className="align-center text-small text-left">
                <template slot-scope="record">
                    {{ record.observation }}
                </template>
            </a-table-column>

            <a-table-column key="session" title="Sesi" className="align-center text-small text-left">
                <template slot-scope="record">
                    {{ record.class_session.name }}
                </template>
            </a-table-column>
        </a-table>

        <a-row type="flex" justify="center" style="margin-top: 12px">
            <a-col>
                <a-space>
                    <a-button
                        @click="handleClose"
                        :loading="processing"
                        :disabled="processing"
                        >Tutup</a-button>
                </a-space>
            </a-col>
        </a-row>

    </a-card>
</template>
